import React, { useContext } from 'react'
import { exit, sideBarList } from '../data/data'
import { NavLink } from 'react-router-dom'
import tmpLogo from '../tmpLogo.svg'
import { UserContext } from '../context/userContext';
import { RouteContext } from '../context/routeContext';

function SideBar() {

  const {removeLocalUser,setUser} = useContext(UserContext);
  const {setActivePage} = useContext(RouteContext);


  const handleLogout = ( ) => {
    setActivePage('/')
      setUser(null);
      removeLocalUser();
  }



  return (
    <div className='bg-sidebar-background h-screen p-2 justify-between flex flex-col w-[300px]' >
      <div>
        <div className='flex items-center justify-center mb-3'>        
          <img src={tmpLogo} alt="TMP logo" className='border-8 rounded-lg border-orange-700 ' />
        </div>
      
        {sideBarList.map((item,index)=>
        <NavLink key={index} to={`${item.route}`} className={({isActive})=>isActive?'flex items-end p-2 bg-white rounded mb-2 max-sm:justify-center max-sm:iten-center' :'flex items-end p-2 mb-2 max-sm:justify-center max-sm:iten-center'} >
            <img src={item.icon} alt={item.lable} width='30' className='mr-2'  />
            <p className='hidden sm:inline-block sm:text-center truncate '>{item.lable}</p>
        </NavLink>
        
        )}
      </div>
    {/* TODO:write logout funtionality */}
    <button className='flex p-5 items-center justify-center mb-5' onClick={handleLogout}>
            <img src={exit.icon} alt={exit.lable} width='30'  />
            <p className='hidden sm:block text-center'>{exit.lable}</p>
    </button>
   </div>
  )
}

export default SideBar